import type { FinalizeVerificationResponse } from './billing-payment.types';

export const parseFinalizeVerificationResponse = (raw: unknown): FinalizeVerificationResponse => {
  if (typeof raw === 'string') {
    try {
      return parseFinalizeVerificationResponse(JSON.parse(raw) as unknown);
    } catch {
      return { subscriptionPaid: false };
    }
  }

  if (typeof raw !== 'object' || raw === null) {
    return { subscriptionPaid: false };
  }

  if ('subscriptionPaid' in raw) {
    return { subscriptionPaid: Boolean((raw as FinalizeVerificationResponse).subscriptionPaid) };
  }

  if ('data' in raw) {
    return parseFinalizeVerificationResponse((raw as { data: unknown }).data);
  }

  return { subscriptionPaid: false };
};
